import { render, staticRenderFns } from "./additional-field.vue?vue&type=template&id=5ea094fc&"
import script from "./additional-field.vue?vue&type=script&lang=js&"
export * from "./additional-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports